import { CVData } from '../types';

const consejero: CVData = {
  profileStatement: {
    es: 'Consejero experto en inteligencia artificial y Directivo Senior con más de 30 años de trayectoria ejecutiva en Industria, Universidad y Sector Público, incluyendo puestos de CEO en tres sectores distintos (sanitario, industrial, consultoría estratégica) y la dirección de la transformación digital, los datos y la inteligencia artificial del Gobierno de La Rioja (equipo de 300 personas, presupuesto de 40 M€). Fundador de Kairos Governance, plataforma de gobernanza de la inteligencia artificial alineada con el Reglamento Europeo de Inteligencia Artificial (EU AI Act) e ISO 42001, y de Teselia, SaaS de contabilidad y ERP con IA generativa y agentes de IA para asesorías y pymes: dos productos propios en dominios regulados, con responsabilidad ejecutiva directa sobre arquitectura, seguridad y cumplimiento normativo: prueba de haber construido tecnología de gobernanza de la IA, no solo de haberla supervisado desde un consejo. Especialista en Gobierno Corporativo, estrategia de IA y ROI, gobernanza y gestión de riesgos de la inteligencia artificial y del riesgo tecnológico, y creación de ecosistemas de emprendimiento y transferencia tecnológica. Profesor del Programa Ejecutivo en Inteligencia Artificial: Estrategia, ROI y Gobernanza de la Universidad San Jorge (curso 2026-2027). Formado en el programa De Directivo a Consejero (IESE, KPMG, AED).',
    en: 'Board Director with artificial intelligence expertise and Senior Executive with over 30 years of executive track record across Industry, University and the Public Sector, including CEO roles in three distinct sectors (healthcare, industry, strategic consulting) and leading the digital, data and artificial intelligence transformation of the Government of La Rioja (team of 300, budget of €40M). Founder of Kairos Governance, an artificial intelligence governance platform aligned with the European Artificial Intelligence Act (EU AI Act) and ISO 42001, and of Teselia, an accounting and ERP SaaS with generative AI and AI agents for accounting firms and SMEs: two in-house products in regulated domains, with direct executive responsibility for architecture, security and regulatory compliance: proof of having built AI governance technology, not just overseen it from a board. Specialist in Corporate Governance, AI strategy and ROI, artificial intelligence governance and risk management and technology risk, and building entrepreneurship and technology transfer ecosystems. Lecturer on the Executive Programme in Artificial Intelligence: Strategy, ROI and Governance at Universidad San Jorge (2026-2027 academic year). Graduate of the From Executive to Board Director programme (IESE, KPMG, AED).',
  },

  heroTagline: {
    es: 'Consejero Independiente · Inteligencia Artificial · Gobierno Corporativo',
    en: 'Independent Board Director · Artificial Intelligence · Corporate Governance',
  },

  heroCTA: {
    es: 'Descargar Perfil CdA',
    en: 'Download Board Profile',
  },

  stats: [
    { value: '30+', label: { es: 'Años de trayectoria ejecutiva', en: 'Years executive track record' } },
    { value: '3', label: { es: 'Consejos de Administración', en: 'Board memberships' } },
    { value: '>100M€', label: { es: 'Presupuesto público gestionado', en: 'Public budget managed' } },
    { value: '9M€', label: { es: 'Fondo VC gestionado', en: 'VC fund managed' } },
  ],

  experience: [
    {
      id: 'teselia',
      period: '2026-Actualidad',
      role: { es: 'Fundador', en: 'Founder' },
      company: 'Teselia',
      sector: { es: 'SaaS contable / FinTech · Fundador', en: 'Accounting SaaS / FinTech · Founder' },
      summary: {
        es: 'Teselia (teselia.es) es un SaaS de contabilidad española y ERP para asesorías y pymes, construido sobre un modelo de marca blanca en el que cada asesoría opera bajo su propia marca, dominio y controles. Segundo producto propio llevado de la idea al mercado, con responsabilidad directa sobre arquitectura, cumplimiento normativo y modelo de negocio.',
        en: 'Teselia (teselia.es) is a Spanish accounting and ERP SaaS for accounting firms and SMEs, built on a white-label model in which each firm operates under its own brand, domain and controls. A second in-house product taken from idea to market, with direct responsibility for architecture, regulatory compliance and business model.',
      },
      responsibilities: [
        {
          es: 'Diseño de controles internos embebidos en el producto: trazabilidad completa de cada asiento, inmutabilidad de lo contabilizado y segregación de accesos impuesta en la capa de datos, no en la interfaz.',
          en: 'Design of internal controls embedded in the product: full audit trail of every journal entry, immutability of posted records and access segregation enforced at the data layer rather than the interface.',
        },
        {
          es: 'Gobierno del riesgo regulatorio: seguimiento del calendario normativo (VeriFactu, factura electrónica, regímenes forales) y traducción de obligaciones legales en requisitos de producto verificables.',
          en: 'Regulatory risk governance: tracking of the regulatory calendar (VeriFactu, e-invoicing, regional tax regimes) and translation of legal obligations into verifiable product requirements.',
        },
        {
          es: 'IA generativa y agentes de IA con uso responsable en un dominio regulado: asistente basado en LLM en el que el sistema propone y una persona confirma toda acción irreversible (supervisión humana), con separación explícita entre lo que un documento dice y lo que el sistema ejecuta.',
          en: 'Generative AI and AI agents used responsibly in a regulated domain: an LLM-based assistant where the system proposes and a human confirms every irreversible action (human oversight), with an explicit separation between what a document states and what the system executes.',
        },
      ],
      tags: ['SaaS', 'FinTech', 'Cumplimiento normativo', 'IA generativa', 'Agentes de IA', 'Fundador'],
      highlight: true,
    },
    {
      id: 'kairos',
      period: '2025-Actualidad',
      role: { es: 'Fundador', en: 'Founder' },
      company: 'Kairos Governance',
      sector: { es: 'Tecnología · Inteligencia Artificial · Fundador', en: 'Technology · Artificial Intelligence · Founder' },
      summary: {
        es: 'Fundador de una plataforma de gobernanza de la inteligencia artificial de 54 módulos que permite a una organización inventariar, evaluar, controlar y supervisar todos sus sistemas de IA, alineada con el Reglamento Europeo de Inteligencia Artificial (EU AI Act), el RGPD, el ENS, ISO 42001 y DORA. Despliegue on-premise para administraciones públicas y empresa europea, en competencia con IBM watsonx.governance, OneTrust y ServiceNow.',
        en: 'Founder of a 54-module artificial intelligence governance platform that lets an organisation inventory, assess, control and oversee all its AI systems, aligned with the European Artificial Intelligence Act (EU AI Act), GDPR, the Spanish National Security Framework (ENS), ISO 42001 and DORA. On-premise deployment for public administrations and European companies, competing with IBM watsonx.governance, OneTrust and ServiceNow.',
      },
      responsibilities: [
        {
          es: 'Gobernanza y gestión de riesgos de la IA: inventario de sistemas de inteligencia artificial con clasificación por nivel de riesgo, evaluaciones de impacto (FRIA y DPIA), supervisión humana y auditoría inmutable, con trazabilidad a EU AI Act, ISO 42001 y NIST.',
          en: 'AI governance and risk management: inventory of artificial intelligence systems with risk-level classification, impact assessments (FRIA and DPIA), human oversight and immutable audit trail, traced to the EU AI Act, ISO 42001 and NIST.',
        },
        {
          es: 'Control de la IA generativa y de los agentes de IA: gateway LLM gobernado con guardarraíles, autorización previa a cada acción de un agente y evaluación de modelos con red teaming.',
          en: 'Control of generative AI and AI agents: governed LLM gateway with guardrails, authorisation before every agent action and model evaluation through red teaming.',
        },
        {
          es: 'Visión de consejo: supervisión de modelos de IA y machine learning (drift, sesgo, explicabilidad) y medición del valor (ROI) de cada caso de uso de inteligencia artificial, la información que un consejo necesita para supervisar la IA de la organización.',
          en: 'Board perspective: oversight of AI and machine learning models (drift, bias, explainability) and measurement of the value (ROI) of each artificial intelligence use case, the information a board needs to oversee the organisation\'s AI.',
        },
      ],
      tags: ['Inteligencia Artificial', 'Gobernanza de IA', 'EU AI Act', 'IA generativa', 'RegTech', 'Fundador', 'Gobierno Corporativo'],
      highlight: true,
    },
    {
      id: 'inetum',
      period: '2025-Actualidad',
      role: { es: 'Director de Sector Público España', en: 'Head of Public Sector Spain' },
      company: 'Inetum',
      sector: { es: 'Tecnología · Multinacional', en: 'Technology · Multinational' },
      summary: {
        es: 'Desarrollo del negocio y estrategia comercial en el sector público, con foco en inteligencia artificial, datos y transformación digital. Diseño de la propuesta de valor para administraciones públicas en IA generativa, agentes de IA, analítica de datos y automatización inteligente, incorporando la gobernanza de la IA y el cumplimiento del Reglamento Europeo de Inteligencia Artificial. Gestión de licitaciones y representación institucional.',
        en: 'Business development and commercial strategy in the public sector, with a focus on artificial intelligence, data and digital transformation. Design of the value proposition for public administrations in generative AI, AI agents, data analytics and intelligent automation, embedding AI governance and compliance with the European Artificial Intelligence Act. Tender management and institutional representation.',
      },
      tags: ['Sector Público', 'Inteligencia Artificial', 'IA generativa', 'Transformación Digital'],
      highlight: true,
    },
    {
      id: 'la-rioja',
      period: '2022-2023',
      role: { es: 'Director General para el Avance Digital (CIO)', en: 'Director General for Digital Advancement (CIO)' },
      company: 'Gobierno de La Rioja',
      sector: { es: 'Sector Público · Administración Regional', en: 'Public Sector · Regional Government' },
      summary: {
        es: 'CIO del Gobierno de La Rioja. Responsable de la transformación digital, los datos y la inteligencia artificial de la administración autonómica con un equipo de 300 personas y un presupuesto de 40 M€: estrategia de IA y datos centrada en el ciudadano, con inteligencia artificial, automatización robótica de procesos (RPA), data lake y analítica de datos. Miembro del Consejo de Administración de ADER y del Consejo Riojano de I+D+i. Licitación NEOTEC de 100 M€.',
        en: 'CIO of the Government of La Rioja. Responsible for the digital, data and artificial intelligence transformation of the regional administration with a team of 300 people and a budget of €40M: a citizen-centred AI and data strategy using artificial intelligence, robotic process automation (RPA), a data lake and data analytics. Board member of ADER and the La Rioja R&D&I Council. €100M NEOTEC tender.',
      },
      tags: ['CIO', 'Gobierno Corporativo', 'Inteligencia Artificial', 'CdA ADER', 'Sector Público', '100M€'],
      highlight: true,
    },
    {
      id: 'unav',
      period: '2015-2022',
      role: { es: 'Director General de Emprendimiento e Innovación', en: 'Director General of Entrepreneurship & Innovation' },
      company: 'Universidad de Navarra',
      sector: { es: 'Universidad · Transferencia Tecnológica', en: 'University · Technology Transfer' },
      summary: {
        es: 'Gestión de fondo VC de 9 M€. Lanzamiento de 9 spin-offs. Fundador de Atelier by ISEM y de ADAN, primera experiencia española de innovación abierta en Big Data e inteligencia artificial entre start-ups y grandes empresas. Advisory boards en start-ups y scale-ups. Representación institucional en ecosistemas de innovación.',
        en: 'Management of a €9M VC fund. Launch of 9 spin-offs. Founder of Atelier by ISEM and of ADAN, Spain\'s first open innovation experience in Big Data and artificial intelligence between start-ups and large companies. Advisory boards in start-ups and scale-ups. Institutional representation in innovation ecosystems.',
      },
      tags: ['Venture Capital', 'Spin-offs', 'Advisory Board', 'Innovación Abierta'],
      highlight: true,
    },
    {
      id: 'harol',
      period: '2005-2006',
      role: { es: 'CEO', en: 'CEO' },
      company: 'Grupo Harol',
      sector: { es: 'Industria · Capital Riesgo', en: 'Industry · Private Equity' },
      summary: {
        es: 'Due-diligence para fondo de capital riesgo MCH y gestión de fusión de tres empresas medianas. Experiencia directa en M&A, reestructuración financiera y gobierno durante proceso de desinversión.',
        en: 'Due diligence for PE fund MCH and management of merger of three mid-size companies. Direct M&A, financial restructuring and governance experience during divestment process.',
      },
      tags: ['M&A', 'Capital Riesgo', 'Due-Diligence', 'Reestructuración'],
      highlight: true,
    },
    {
      id: 'medicis',
      period: '2006-2014',
      role: { es: 'Fundador / CEO', en: 'Founder / CEO' },
      company: 'Médicis',
      sector: { es: 'HealthTech · Emprendimiento', en: 'HealthTech · Entrepreneurship' },
      summary: {
        es: 'Fundación y liderazgo del primer centro de diagnóstico por imagen privado en Navarra. Visión estratégica, captación de inversión, desarrollo de plataforma de telediagnóstico y gestión del crecimiento.',
        en: 'Founded and led the first private medical imaging centre in Navarre. Strategic vision, investment raising, tele-diagnosis platform development and growth management.',
      },
      tags: ['Fundador', 'HealthTech', 'Inversión', 'Telemedicina'],
      highlight: true,
    },
  ],

  education: [
    {
      degree: { es: 'Ingeniero Industrial (Electrónica y Organización)', en: 'Industrial Engineer (Electronics & Organisation)' },
      institution: 'Universidad de Navarra',
      year: '1988-1993',
      tags: ['Ingeniería', 'Electrónica', 'Organización Industrial'],
    },
    {
      degree: { es: 'PDG: Programa de Dirección General', en: 'PDG: General Management Programme' },
      institution: 'IESE Business School',
      year: '1997',
      tags: ['Management', 'Liderazgo'],
    },
    {
      degree: { es: 'De Directivo a Consejero (4ª Promoción)', en: 'From Executive to Board Director (4th cohort)' },
      institution: 'IESE · KPMG · AED',
      year: '2019',
      tags: ['Gobierno Corporativo', 'CdA', 'Consejero'],
    },
  ],

  competencies: [
    {
      groupTitle: { es: 'Gobernanza y Estrategia', en: 'Governance & Strategy' },
      items: [
        { es: 'Gobierno corporativo', en: 'Corporate governance' },
        { es: 'Gestión de riesgos', en: 'Risk management' },
        { es: 'Supervisión estratégica (M&A)', en: 'Strategic oversight (M&A)' },
        { es: 'Resiliencia organizativa', en: 'Organisational resilience' },
        { es: 'Sostenibilidad (ESG Digital)', en: 'Sustainability (Digital ESG)' },
        { es: 'Responsabilidad fiduciaria', en: 'Fiduciary responsibility' },
      ],
    },
    {
      groupTitle: { es: 'Inteligencia Artificial y Transformación', en: 'Artificial Intelligence & Transformation' },
      items: [
        { es: 'Estrategia de inteligencia artificial y ROI', en: 'Artificial intelligence strategy and ROI' },
        { es: 'Gobernanza y riesgos de la IA (EU AI Act, ISO 42001)', en: 'AI governance and risk (EU AI Act, ISO 42001)' },
        { es: 'IA generativa, LLM y agentes de IA', en: 'Generative AI, LLMs and AI agents' },
        { es: 'Datos, analítica y machine learning', en: 'Data, analytics and machine learning' },
        { es: 'Automatización avanzada y reingeniería', en: 'Advanced automation and reengineering' },
        { es: 'Innovación tecnológica', en: 'Technological innovation' },
      ],
    },
    {
      groupTitle: { es: 'Ecosistemas e Industria', en: 'Ecosystems & Industry' },
      items: [
        { es: 'Colaboración público-privada', en: 'Public-private collaboration' },
        { es: 'Transferencia tecnológica', en: 'Technology transfer' },
        { es: 'Venture Capital y spin-offs', en: 'Venture Capital and spin-offs' },
        { es: 'Relaciones institucionales B2G', en: 'Institutional B2G relations' },
        { es: 'Liderazgo de ecosistemas', en: 'Ecosystem leadership' },
        { es: 'Internacionalización', en: 'Internationalisation' },
      ],
    },
  ],

  boardMemberships: [
    {
      role: { es: 'Miembro Consejo de Administración', en: 'Board Member' },
      organization: 'ADER (Agencia de Desarrollo Económico de La Rioja)',
      period: '2022-2023',
      description: {
        es: 'Agencia pública de desarrollo económico regional. Participación en la definición de estrategia de atracción de inversión y transformación del tejido productivo riojano.',
        en: 'Regional public economic development agency. Participation in defining investment attraction strategy and transformation of the La Rioja productive fabric.',
      },
    },
    {
      role: { es: 'Miembro', en: 'Member' },
      organization: 'Consejo Riojano de I+D+i',
      period: '2022-2023',
      description: {
        es: 'Órgano asesor del Gobierno de La Rioja en materia de investigación, desarrollo e innovación tecnológica.',
        en: 'Advisory body to the Government of La Rioja on research, development and technological innovation.',
      },
    },
    {
      role: { es: 'Miembro Comité Permanente', en: 'Permanent Committee Member' },
      organization: 'Fundación Moderna',
      period: '2010-2014',
      description: {
        es: 'Instrumento de planificación estratégica a largo plazo para la región de Navarra. Definición de hoja de ruta para la transformación económica y social de Navarra.',
        en: 'Long-term strategic planning instrument for the Navarre region. Definition of roadmap for economic and social transformation of Navarre.',
      },
    },
  ],

  techStack: [
    'IA generativa / LLM', 'Agentes de IA', 'RAG', 'MCP', 'Python', 'SQL / Supabase', 'Power BI',
    'Tableau', 'n8n', 'RPA', 'Cloud (AWS / Azure)',
    'Data Lakes', 'JavaScript', 'React',
  ],

  contactCTA: {
    es: 'Disponible para posiciones en Consejo de Administración',
    en: 'Available for Board of Directors positions',
  },
};

export default consejero;
